import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=7ca9706a&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=7ca9706a&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/scania_guess_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ca9706a"]])

export default __exports__